export default {
      id: "ic_bilyonerganyan-usage",
      viewBox: "0 0 24 21",
      url: "/" + "images/icons.3.109.2.svg#ic_bilyonerganyan-usage",
      toString: function () {
        return this.url;
      }
    }